import React from 'react';
import { BrowserRouter, HashRouter, Navigate, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { SiteContentProvider } from './contexts/SiteContentContext';
import './site/styles/base.css';
import './site/styles/secondary.css';
import './site/styles/page-products.css';
import './site/styles/page-learn.css';
import './site/styles/page-solutions.css';
import './site/styles/page-partnerships.css';
import './site/styles/page-about.css';
import './site/styles/page-contact.css';
import './site/site.css';
import { Header, Footer, RouteEffects, pageKey } from './site/Layout';
import HomePage from './site/pages/Home';
import ProductsPage from './site/pages/Products';
import ProductDetailPage from './site/pages/ProductDetail';
import SolutionsPage from './site/pages/Solutions';
import PartnershipsPage from './site/pages/Partnerships';
import AboutPage from './site/pages/About';
import ContactPage from './site/pages/Contact';
import NotFoundPage from './site/pages/NotFound';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import SafeClaw from './components/SafeClaw';
import { isLayoutDemo } from './demo';

const Router = isLayoutDemo ? HashRouter : BrowserRouter;

function Site() {
  const { pathname } = useLocation();
  return (
    <div className={`site pg-${pageKey(pathname)}`}>
      <Header />
      <main id="main-content" tabIndex="-1">
        <RouteEffects />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/nexcus" element={<Navigate to="/products/nexus" replace />} />
          <Route path="/products/:slug" element={<ProductDetailPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {!isLayoutDemo && <Route path="/safeclaw" element={<SafeClaw />} />}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <SiteContentProvider>
        <Router>
          <Site />
        </Router>
      </SiteContentProvider>
    </LanguageProvider>
  );
}

export default App;
